export default "__VITE_ASSET__4f2b6007__"